export default __webpack_public_path__ + "static/media/votingApp.cf7f33c0.png";